import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { toast } from "@/components/ui/use-toast";

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function deliverExport(blob, filename) {
  if (Capacitor.isNativePlatform()) {
    const data = await blobToBase64(blob);
    // Keep a persistent local copy in the app's Documents directory, while
    // using the cache directory for the share operation so Android can
    // reliably hand the file to other apps. The Documents copy survives
    // cache cleanup and remains available from the device's file storage.
    await Filesystem.writeFile({
      path: `DrillLogPro/${filename}`,
      data,
      directory: Directory.Documents,
      recursive: true,
    });
    const extension = filename.split(".").pop()?.toLowerCase();
    const exportLabel = extension === "csv" ? "CSV" : "PDF";
    toast({
      title: `${exportLabel} downloaded successfully`,
      description: `Saved as ${filename}`,
      duration: 6000,
    });
    await Filesystem.writeFile({
      path: filename,
      data,
      directory: Directory.Cache,
      recursive: true,
    });
    const { uri } = await Filesystem.getUri({
      path: filename,
      directory: Directory.Cache,
    });
    await Share.share({
      title: filename,
      text: `DrillLogPro export: ${filename}`,
      url: uri,
      dialogTitle: "Export file",
    });
    return;
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
